import React, { useEffect, useRef, useState } from "react";
import styles from "./VendorHeader.module.scss";
import profile_partner_icon from "../../../assets/svg/userProfile.svg";
import logout_outlined from "../../../assets/svg/logout_outlined.svg";
import { doLogout, getVendorDecodedTokenData } from "../../../common/utility";
import { Paths } from "../../../Routes/path";
import arrowUpper from "../../../assets/svg/arrowUpper.svg";
import lock_icon from "../../../assets/svg/lock.svg";
import logo from "../../../assets/svg/airtel-logo.svg";
import vendorLogo from "../../../assets/svg/vendor.svg";
import Env from "../../../Environments";

function useOutsideAlerter(ref, cbk) {
  useEffect(() => {
    function handleClickOutside(event) {
      if (ref.current && !ref.current.contains(event.target)) {
        cbk(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
    // eslint-disable-next-line
  }, [ref]);
}

const VendorHeader = () => {
  const [open, setOpen] = useState(false);
  const decoded_token = getVendorDecodedTokenData();
  const wrapperRef = useRef(null);
  useOutsideAlerter(wrapperRef, setOpen);

  return (
    <div className={styles.headerComponent}>
      <div className={styles.headerElement}>
        <img src={logo} alt="" className={styles.pointer} />
        <img src={vendorLogo} alt="" className={styles.pointer} />
      </div>
      <div className={styles.headerElement}>
        <div className={styles.profileSection} onClick={() => setOpen(!open)}>
          <img
            src={profile_partner_icon}
            alt="logo"
            width={40}
            height={40}
            className={styles.pointer}
          />
          <div className={styles.idSection}>
            {decoded_token && (
              <>
                <span className={styles.name}>
                  {decoded_token.name}
                  <img
                    src={arrowUpper}
                    alt="uparrow"
                    className={`${styles.up} ${open && styles.open}`}
                    width={20}
                    height={20}
                  />
                </span>
              </>
            )}
          </div>

          {open && (
            <div ref={wrapperRef}>
              <div className={styles.profileOverlay} />
              <div className={styles.profileDropdown}>
                <div
                  className={`${styles.logout} ${styles.option}`}
                  onClick={() => {
                    window.open(
                      window.location.origin +
                        Env.getVendorBasePath() +
                        Paths.vendorFogotPassword.path,
                      "_blank"
                    );
                  }}
                >
                  <img src={lock_icon} alt="change password" />
                  Change Password
                </div>
                <div
                  className={`${styles.logout} ${styles.option}`}
                  onClick={() => {
                    doLogout();
                  }}
                >
                  <img src={logout_outlined} alt="logout" />
                  Log Out
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default VendorHeader;
